import { FireOutbreak } from '../../../../@core/fire-risk-dashboard/domain/entities/FireOutbreak'
import { FireOutbreakOccurrenceEnum } from '../../../../@core/fire-risk-dashboard/domain/enum/FireOutbreakOccurence.enum'

export class FireOutbreakAlertWhatsappMessageFactory {
	static make(fireOutbreak: FireOutbreak) {
		return `
🔥 *Alerta de Incêndio!* 🔥

⚠️ Ocorrência *${fireOutbreak.occurrence === FireOutbreakOccurrenceEnum.BUFFER ? 'no Buffer de Segurança da Fazenda!' : 'na Fazenda'}* ⚠️

🧮 Confiança da Detecção: *${fireOutbreak.detectionConfidenceLabel}*

🏡 *Fazenda:* ${fireOutbreak.farm}

⏰ *Timestamp Ocorrência:* ${fireOutbreak.detectedAtLabel}

🌎 *Localização:*

Latitude: ${fireOutbreak.latitude}

Longitude: ${fireOutbreak.longitude}
    `
	}
}
